export const APIPATH = process.env.REACT_APP_API_URL
export const PYADMINPATH = process.env.REACT_APP_ADMIN_API_PY
// export const ISCASTLERACTIVE = process.env.REACT_APP_ACTIVE_CASTLER
// export const DIGI_LOCKER_SDK = "https://app.digio.in/sdk/v10/digio.js";
export const DIGI_LOCKER_SDK_ESIGN = process.env.REACT_APP_DIGI_LOCKER_E_SIGN
export const DIGI_LOCKER_SDK = process.env.REACT_APP_DIGI_LOCKER
export const Assets_Url = "https://d3kgk0blw9vqbg.cloudfront.net/"
export const IFSCURL = "https://ifsc.razorpay.com/";
export const EQUIFAXURL = "http://13.234.206.255:8081/api/";
export const PINE_PG = process.env.REACT_APP_PINE_LAB_URL;
export const ENACH_ENV = process.env.REACT_APP_ENACH;
export const SDK_ENV = process.env.REACT_APP_SDK_ENV
export const KARZA_VERIFY = "https://testapi.karza.in"
export const STATEMENTANALYSIS = "https://api.alphamoney.in/api"
export const GEO_LOCATION_WEB_KEY=process.env.REACT_APP_GEO_LOCATION
export const APPLY_LOAN_AFTER_ACTIVE=process.env.REACT_APP_LOAN_APPROVAL
export const IKEDA_USER_REDIRECTION =process.env.REACT_APP_REDIRECT_IKEDA
export const REDIRECTION_PERFORM =process.env.REACT_APP_ENV
export const AI_ML_URL =process.env.REACT_APP_ML_URL
export const PAN_NOTIFY =process.env.REACT_APP_PAN_NOTIFY
export const ADHAAR_NOTIFY =process.env.REACT_APP_ADHAAR_NOTIFY
export const SUPPORT_TICKET_ORIGIN =process.env.REACT_APP_SUPPORT_TICKET_ORIGIN
export const ANDROID_STORE_URL = process.env.REACT_APP_ANDROID_STORE_URL;
export const IOS_STORE_URL = process.env.REACT_APP_IOS_STORE_URL;
export const POSTSANCTION_ORIGIN = process.env.REACT_APP_POSTSANCTION_ORIGIN



